<template>
  <div class="myswiper-All">
    <div class="myswiper-container">
      <div class="swiper-outer-div">
        <swiper :options="swiperOptions" ref="mySwiper">
          <swiper-slide v-for="(item, index) in swiperList.rows" :key="index">
            <div :class="{ 'swiper-Border': index === realIndex }"></div>
<!--            <img-->
<!--              class="swiper-img"-->
<!--              :src="item.images"-->
<!--              :class="{ 'swiper-img-current': index === realIndex }"-->
<!--            />-->
            <img :src="item.colorImages" v-if="index === realIndex" class ="swiper-img swiper-img-current"/>
            <img :src="item.images" class="swiper-img" v-else />
          </swiper-slide>
        </swiper>
      </div>

      <div class="myswiper-bottom">
        <div class="swiper-button-prev" @click="prev()"></div>
        <div class="swiper-text">
          <div class="swiper-name">
            {{ swiperList.rows[realIndex].userName }}
          </div>
          <div class="swiper-desc">
            {{ swiperList.rows[realIndex].introduction }}
          </div>
        </div>
        <div class="swiper-button-next" @click="next()"></div>
      </div>
    </div>
  </div>
</template>

<script>
// import { Swiper, SwiperSlide } from "vue-awesome-swiper";
// import { GetPartnerList } from "../../assets/server/api";
// import "swiper/swiper.less";
export default {
  name: "TeamMember",
  // components: {
  //   Swiper,
  //   SwiperSlide,
  // },
  computed: {
    // currentSwiperData() {
    //   //当前slide数据
    //   console.log(this.swiperList[this.realIndex]);
    //   return this.swiperList[this.realIndex];
    // },
    // swiper() {
    //   return this.$refs.mySwiper.$swiper;
    // },
  },
  watch: {},
  data() {
    let _this = this;
    return {
      realIndex: 0, //轮播图滚动当前index
      timer: null,
      swiperOptions: {
        // direction: 'vertical',
        notNextTick: true,
        centeredSlides: true,
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        slidesPerView: 5, //一行显示5个
        spaceBetween: 22.5, //间隔
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          slideChangeTransitionStart: function () {
            _this.realIndex = this.realIndex;
          },
          slideChangeTransitionEnd() {},
          slideChange: () => {},
        },
      },
      observer: true, // 修改swiper自己或子元素时，自动初始化swiper
      observeParents: true, // 修改swiper的父元素时，自动初始化swiper
      swiperList: [],
    };
  },
  created() {
   // this.GetPartnerList();
  },
  methods: {
    // 核心成员
    async GetPartnerList() {
      const data = await GetPartnerList();
      // console.log(data);
      if (data.code === 0) {
        // data.rows.forEach((item) => {
        //   item.images1 = "https://www.donetwork.io/team/chris.png";
        // });
        this.swiperList = data;
      } else {
        this.$message.error(data.msg);
      }



    },
    init() {
      let _this = this;
      this.timer = setInterval(() => {
        _this.swiper.slideNext(500);
      }, 3000);
    },
    prev() {
      this.$refs.mySwiper.$swiper.slidePrev();
    },
    next() {
      this.$refs.mySwiper.$swiper.slideNext();
    },
  },
  destroyed() {
    clearInterval(this.timer);
  },
  mounted() {
   // this.init();
  },
};
</script>

<style lang="less" scoped>
@media screen and (min-width: 1024px) {
  .myswiper-All {
    background-position: 0 3%;
  }
}
@media screen and (min-width: 1100px) {
  .myswiper-All {
    background-position: 0 3%;
  }
}
@media screen and (min-width: 1280px) {
  .myswiper-All {
    background-position: 0 3%;
  }
}
@media screen and (min-width: 1366px) {
  .myswiper-All {
    background-position: 0 3%;
  }
}
@media screen and (min-width: 1440px) {
  .myswiper-All {
    background-position: 0 3%;
  }
}
@media screen and (min-width: 1680px) {
  .myswiper-All {
    background-position: 0 3%;
  }
}
@media screen and (min-width: 1920px) {
  .myswiper-All {
    background-position: 0 -135px;
  }
}
@media screen and (min-width: 2048px) {
  .myswiper-All {
    background-position: 0 3%;
  }
}
@media screen and (min-width: 2560px) {
  .myswiper-All {
    background-position: 0 3%;
  }
}
@media screen and (min-width: 3024px) {
  .myswiper-All {
    background-position: 0 3%;
  }
}
@media screen and (min-width: 4096px) {
  .myswiper-All {
    background-position: 0 3%;
  }
}
.myswiper-All {
  width: 100%;
  background-image: url("../../assets/pc/pc_team_bg@2x.png");
  background-repeat: no-repeat;
  background-size: 100%;
  margin-top: 100px;
}
.myswiper-container {
  width: 1200px;
  height: 537px;
  margin: 0 auto;
  .swiper-outer-div {
    // border: 1px solid #f00;
  }
  .swiper-container {
    position: relative;
    top: 200px;
    padding-top: 47px;
    width: 657px;
    height: 340px;
    .swiper-wrapper {
      .swiper-slide {
        text-align: center;
        .swiper-Border {
          width: 130px;
          height: 130px;
          border: 2px solid #4573e7;
          border-radius: 50%;
          position: absolute;
          top: -20px;
          left: -5px;
        }
        .swiper-img {
          width: 73px;
          height: 73px;
          border-radius: 50%;
        }
        .swiper-img-current {
          margin-top: -15px;
          width: 120px;
          height: 120px;
          border-radius: 50%;
        }
      }
    }
  }
  .myswiper-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0 20px 20px;
    height: 150px;
    margin-top: 80px;
    .swiper-button-prev {
      width: 65px;
      height: 65px;
      background: url("../../assets/pc/team_prev.png") no-repeat;
      background-size: 100%;
      border-radius: 50%;
      margin-top: 10px;
      img {
        width: 40px;
        height: 40px;
        cursor: pointer;
      }
    }
    .swiper-button-prev:hover {
      background: url("../../assets/pc/team_next.png") no-repeat;
      background-size: 100%;
      transform: rotate(180deg);
    }
    .swiper-button-next {
      width: 65px;
      height: 65px;
      background: url("../../assets/pc/team_prev.png") no-repeat;
      background-size: 100%;
      transform: rotate(180deg);
      border-radius: 50%;
      margin-top: 10px;
      img {
        width: 40px;
        height: 40px;
        cursor: pointer;
      }
    }
    .swiper-button-next:hover {
      background: url("../../assets/pc/team_next.png") no-repeat;
      background-size: 100%;
      transform: rotate(0deg);
    }
    .swiper-text {
      text-align: center;
      margin-left: 40px;
      margin-right: 40px;
      .swiper-name {
        height: 26px;
        font-size: 22px;
        font-family: Poppins-Bold, Poppins;
        font-weight: bold;
        color: #4573e7;
        line-height: 26px;
        -webkit-background-clip: text;
      }
      .swiper-desc {
        margin: 30px 110px 0;
        width: 360px;
        height: 58px;
        font-size: 16px;
        font-family: Poppins-Regular, Poppins;
        font-weight: 400;
        color: #000000;
        line-height: 27px;
        -webkit-background-clip: text;
      }
    }
  }
}
</style>
